import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Avatar, IconButton } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { Button } from "../../../components/Button/Button";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { meetupsDetailsApi } from "../../../services/meetups";
import { catchMessage, elseMessage } from "../../../comman/Message";
import {
  capitalizeFirstLetter,
  dateFormat,
  dateTime,
  dayAndDate,
  onlyTime,
} from "../../../components/Form";
import IntrestedMember from "./InterestedMember";
import HideMeetupEvent from "./HideEvent";
// import { catchMessage, elseMessage } from '../../comman/Message'

const MeetupsDetails = () => {
  const { id } = useParams();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [meetupsDetails, setMeetupsDetails] = useState({});
  const [value, setValue] = useState("");
  const [statusModal, setStatusModal] = useState(false);
  //--------------fath-API--------------------
  const getSingleCommunity = async () => {
    try {
      showLoader();
      const res = await meetupsDetailsApi(id);
      hideLoader();
      if (res?.data?.status === 200) {
        setMeetupsDetails(res?.data?.data?.meetup || "");
        setValue(res?.data?.data || "");
      } else {
        elseMessage(res);
        hideLoader();
      }
    } catch (err) {
      catchMessage(err);
      hideLoader();
    }
  };
  const statusUpdateHandler = () => {
    setStatusModal(true);
  };
  const currentTime = new Date();
  // Combine date and time for the meetup start
  const startDateTime = new Date(
    `${meetupsDetails?.startDate}T${meetupsDetails?.startTime}`
  );

  // Check if the current time is equal to or after the start date and time
  const isClickable = currentTime >= startDateTime;

  useEffect(() => {
    getSingleCommunity();
  }, [id]);

  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">
              <Link to={-1}>
                <IconButton>
                  <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
                </IconButton>
              </Link>
              {value?.communityName || "N/A"}
            </h4>
            {/* {meetupsDetails?.meetupType == "private" ? (
              <Button className="mx-2">Hide</Button>
            ) : (
              <Button className="mx-2" onClick={statusUpdateHandler}>
                Hide event
              </Button>
            )} */}
          </div>
          <div className="row">
            <div className="col-6">
              <Avatar
                variant="rounded"
                src={meetupsDetails?.coverImage}
                sx={{
                  width: 400,
                  height: 200,
                  cursor: "Pointer",
                  border: 1,
                  borderRadius: 3,
                  borderColor: "#9dc4b4",
                }}
              >
                <InsertPhotoIcon sx={{ fontSize: 100 }} />
              </Avatar>
            </div>
            <div className="col-6">
              <h4>{meetupsDetails?.title || "N/A"}</h4>
              <p className="mt-2 mb-2">
                <b>{capitalizeFirstLetter(meetupsDetails?.categoryType)}</b>
                {meetupsDetails?.categoryType === "physical" && (
                  <>
                    <LocationOnIcon sx={{ color: "#C86337" }} />
                    <b>
                      {meetupsDetails?.country?.name ?? ""}
                      {meetupsDetails?.city?.name
                        ? `, ${meetupsDetails.city.name}`
                        : ""}
                      {meetupsDetails?.state?.name
                        ? `, ${meetupsDetails.state.name}`
                        : ""}
                    </b>
                  </>
                )}{" "}
                :{" "}
                {/* {meetupsDetails?.meetingLink && (
                  <a
                    href={meetupsDetails.meetingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b>{meetupsDetails.meetingLink}</b>
                  </a>
                )} */}
                {meetupsDetails?.categoryType === "virtual" && (
                  <> {meetupsDetails?.meetingLink &&
                    (isClickable ? (
                      // If the link is clickable
                      <a
                        href={meetupsDetails.meetingLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <b>{meetupsDetails.meetingLink}</b>
                      </a>
                    ) : (
                      // If the link is not clickable, show it as plain text
                      <b>{meetupsDetails.meetingLink}</b>
                    ))}
                  </>
                )
                }
              </p>
              <p>
                Host:
                <b className="cstm_b">
                  <Link to={`/user-management/view-details/${value?.userId}`}>
                    {value?.hostName || ""}
                  </Link>
                </b>
              </p>
              <p className="mt-2 mb-2 line-break">
                {meetupsDetails?.about || ""}
              </p>
              <b>
                <p>
                  {dayAndDate(meetupsDetails?.startDate)} {onlyTime(meetupsDetails?.startTime,meetupsDetails?.timeZone)} -  {dayAndDate(meetupsDetails?.startDate)} {onlyTime(meetupsDetails?.endTime,meetupsDetails?.timeZone)}
                </p>
              </b>
            </div>
          </div>
          <IntrestedMember id={id} />
        </div>
      </div>
      <HideMeetupEvent
        show={statusModal}
        close={() => setStatusModal(false)}
        id={meetupsDetails._id}
        listing={getSingleCommunity}
        name={meetupsDetails?.title}
      />
    </>
  );
};

export default MeetupsDetails;
